// Central tab configuration for admin modules. Add a new module or tab here
// first, then reuse it in the module screen and dashboard navigation.
export const ADMIN_MODULE_TABS = {
  "/admin/students": [
    { key: "directory", label: "Directory", icon: FaListUl },
    { key: "metrics", label: "Metrics", icon: FaChartBar },
    { key: "admission", label: "Admission", icon: FaIdBadge },
    { key: "fees", label: "Fee tracker", icon: FaMoneyBillWave },
    { key: "parents", label: "Parent contacts", mobileLabel: "Parents", icon: FaAddressBook },
    { key: "activity", label: "Activity", icon: FaClock },
  ],
};

export const getAdminModuleTabs = (modulePath) => ADMIN_MODULE_TABS[modulePath] || [];
import {
  FaAddressBook,
  FaChartBar,
  FaClock,
  FaIdBadge,
  FaListUl,
  FaMoneyBillWave,
} from "react-icons/fa";
